var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 */
export var Warning = svgIcon(function (props) { return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { fill: "currentColor", d: "M10 1.6C14.65 1.6 18.4 5.4 18.4 10C18.4 14.6 14.65 18.4 10 18.4C5.35 18.4 1.6 14.65 1.6 10C1.6 5.35 5.35 1.6 10 1.6ZM10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0Z" }),
    React.createElement("path", { fill: "currentColor", d: "M11 4.90002H8.90002V11.75H11V4.90002Z" }),
    React.createElement("path", { fill: "currentColor", d: "M9.95002 12.95C9.35002 12.95 8.90002 13.4 8.90002 14C8.90002 14.6 9.35002 15.05 9.95002 15.05C10.55 15.05 11 14.6 11 14C11 13.4 10.55 12.95 9.95002 12.95Z" }))); });
//# sourceMappingURL=Warning.js.map